import { createJSONRequest } from './create-request.js'

/**
 * The operational triggers on the Augmented Actor Profile: migrating a Transition Map score into
 * per-transition scores, and handing an enrichment run to the AI stack.
 *
 * DataScouts staff only — the endpoints answer 403 for anyone else, so callers should hide the
 * controls rather than rely on the request failing.
 */
export const fetchActorAapOperations = (actorId) => createJSONRequest({
  url: `/api/actors/${actorId}/aap-operations`,
  method: 'GET',
})

/**
 * `transition` is required: a radar report does not record which transition it covers, so the
 * caller has to say. Runs synchronously and answers 422 when the migration wrote nothing.
 */
export const migrateActorTransitionScore = (actorId, transition) => createJSONRequest({
  url: `/api/actors/${actorId}/aap-operations/transition-score-migration`,
  method: 'POST',
  data: { transition },
})

/** Fire-and-report: the response says the run started, not that it finished. */
export const triggerActorAapEnrichment = (actorId) => createJSONRequest({
  url: `/api/actors/${actorId}/aap-operations/enrichment`,
  method: 'POST',
})
